/**
 * RatingField Styles
 *
 * Task: T-P5-D4-F2-3
 * Feature: P5-D4-F2 Shared Form Contract Upgrade
 *
 * Star rating field with 5 tappable stars.
 * Uses design system CSS variables from globals.css.
 */

/* ═══════════════════════════════════════════════════════════
   STAR GROUP CONTAINER
   ═══════════════════════════════════════════════════════════ */

.starGroup {
  display: flex;
  gap: var(--space-2);
  align-items: center;
}

/* ═══════════════════════════════════════════════════════════
   INDIVIDUAL STAR BUTTON
   ═══════════════════════════════════════════════════════════ */

.star {
  display: grid;
  place-items: center;
  width: 44px;
  height: 44px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  color: var(--color-bg-secondary);
  transition: color 0.15s var(--ease-out), transform 0.15s var(--ease-bounce);
  -webkit-tap-highlight-color: transparent;
}

/* Hover-grow only on real pointers — on touch, :hover STICKS after a tap, which
   left the last-tapped star permanently enlarged. */
@media (hover: hover) {
  .star:hover {
    transform: scale(1.15);
  }
}

.star:active {
  transform: scale(0.95);
}

.star svg {
  width: 28px;
  height: 28px;
}

/* ═══════════════════════════════════════════════════════════
   STAR STATES
   ═══════════════════════════════════════════════════════════ */

.star.filled {
  color: var(--color-accent-text);
}

.star.filled svg {
  fill: currentColor;
}

.star.outline {
  color: var(--color-text-muted);
}

.star.outline svg {
  fill: none;
}

/* ═══════════════════════════════════════════════════════════
   CWR 2.5 — booking-form stars use the client theme accent (not the admin
   terracotta --color-accent). Scoped to the booking form; admin is untouched.
   ═══════════════════════════════════════════════════════════ */
:global([data-form-appearance='clientBooking']) .star.filled {
  color: var(--accent);
}
:global([data-form-appearance='clientBooking']) .star.outline {
  color: var(--text-muted);
}
